import React, {useState} from 'react'
import { TooltipWrapper, Tooltip } from './customTooltip.styles';
import {InfoIconSVG} from './customTooltip.constants'
import { useIntl } from 'gatsby-plugin-intl';

export const CustomTooltip = ({connection = {}, citation = {}}) => {
  let timeout;
  const [active, setActive] = useState(false);
  const {formatMessage} = useIntl()

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, 200);
  };

  const hideTip = () => {
    timeout = setTimeout(() => {
      setActive(false);
    }, 2000);
  };

  if(!connection.value && !citation.value) return null

  if(connection.value && !citation.value) {
    return (
      <TooltipWrapper
        onMouseEnter={showTip}
        onMouseLeave={hideTip}
      >
        <InfoIconSVG />
        {active && (
          <Tooltip>
            <a href={connection.value} target="_blank" rel="noreferrer">{formatMessage({ id:'Click to View Source'})}</a>
          </Tooltip>
        )}
      </TooltipWrapper>
    )
  } if (!connection.value && citation.value){
    return (
      <TooltipWrapper
        onMouseEnter={showTip}
        onMouseLeave={hideTip}
      >
        <InfoIconSVG />
        {active && (
          <Tooltip>
            {formatMessage({id: citation.value})}
          </Tooltip>
        )}
      </TooltipWrapper>
    )
  }
    return (
      <TooltipWrapper
        onMouseEnter={showTip}
        onMouseLeave={hideTip}
      >
        <InfoIconSVG />
        {active && (
          <Tooltip>
            {formatMessage({id: citation.value})}
            <a href={connection.value} target="_blank" rel="noreferrer">{formatMessage({ id:'Click to View Source'})}</a>
          </Tooltip>
        )}
      </TooltipWrapper>
    )
  }